import React, { Component } from 'react';
import enumCache from '@/shared/services/EnumCacheService';
import DataCacheService from '@/shared/services/DataCacheService';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';

import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  Unassigned: 'Unassigned',
  Profiles: 'Profiles',
  Users: 'Users',
  ResetToTemplateSetting: 'Reset to template setting',
});
class AssignedToSelector extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func.isRequired,
    showReset: PropTypes.bool,
    resetLabel: PropTypes.string,
    profiles: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, label: PropTypes.string })),
    resetIsInitialValue: PropTypes.bool,
  };
  static defaultProps = {
    showReset: false,
    profiles: undefined,
    resetIsInitialValue: false,
    resetLabel: undefined,
  };

  state = {
    profiles: [],
    users: [],
  };

  componentDidMount() {
    const { intl, profiles, resetIsInitialValue } = this.props;
    const profilesPromise =
      profiles && profiles.length > 0
        ? Promise.resolve(profiles)
        : enumCache.getTranslated('employeeprofile', intl);

    profilesPromise.then(data => {
      this.setState({
        profiles: data,
        users: DataCacheService.getUsers(),
        selectedAssignedTo: resetIsInitialValue ? '-1;' : '0;',
      });
    });
  }

  selectedValueChanged(e) {
    const { onChange } = this.props;

    const assignedToString = e.target.value;
    const parts = assignedToString.split(';');

    let model = {
      assignedType: 0,
      assignedUserId: null,
      assignedProfile: null,
      reset: false,
    };

    if (parts.length === 2 && parts[0].length) {
      if (parts[0] === '-1') {
        model = { ...model, reset: true };
      } else if (parts[1].length) {
        if (parts[0] === '1') {
          model = {
            ...model,
            assignedType: 1,
            assignedProfile: parseInt(parts[1]),
          };
        } else if (parts[0] === '2') {
          model = {
            ...model,
            assignedType: 2,
            assignedUserId: parts[1],
          };
        }
      }
    }
    this.setState({ selectedAssignedTo: assignedToString });
    onChange(model);
  }

  render() {
    const { profiles, users, selectedAssignedTo } = this.state;
    const { intl, showReset, resetLabel } = this.props;

    return (
      <select
        value={selectedAssignedTo}
        className="form-control"
        onChange={e => this.selectedValueChanged(e)}
      >
        <option value="0;">{intl.formatMessage(messages.Unassigned)}</option>
        {showReset ? (
          <option value="-1;">
            {resetLabel ? resetLabel : intl.formatMessage(messages.ResetToTemplateSetting)}
          </option>
        ) : null}
        <optgroup label={intl.formatMessage(messages.Profiles)}>
          {profiles &&
            profiles.map(profile => (
              <option key={`1;${profile.id}`} value={`1;${profile.id}`}>
                {profile.label}
              </option>
            ))}
        </optgroup>
        <optgroup label={intl.formatMessage(messages.Users)}>
          {users &&
            users.map(user => (
              <option key={`2;${user.id}`} value={`2;${user.id}`}>
                {user.name}
              </option>
            ))}
        </optgroup>
      </select>
    );
  }
}

export default injectIntl(AssignedToSelector);
